import { render, staticRenderFns } from "./list.vue?vue&type=template&id=107cd038"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107cd038')) {
      api.createRecord('107cd038', component.options)
    } else {
      api.reload('107cd038', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=107cd038", function () {
      api.rerender('107cd038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/point/list.vue"
export default component.exports